module.exports = __webpack_public_path__ + "img/spaghetti-monster-flying.9dced682.svg";